// donationOptions.js
// export const DONATION_OPTIONS = [
//   { id: "archana", label: "Archana Seva", amount: 1501 },
//   { id: "feed_50", label: "Feed 50 people", amount: 1500 },
//   { id: "feed_100", label: "Feed 100 people", amount: 3000 },
//   { id: "feed_200", label: "Feed 200 people", amount: 6000 },
//   { id: "feed_500", label: "Feed 500 people", amount: 15000 },
//   { id: "annadan", label: "I would like to donate for Annadan", amount: 3000 },
//   { id: "gau_seva", label: "Gau Seva", amount: 10000 },
//   { id: "custom", label: "Donate as your wish", amount: null }
// ];

export const DONATION_OPTIONS = [
  { id: "General_Donation", label: "General Donation" },
  { id: "Annadaan_Seva", label: "Annadaan Seva" },
  { id: "Gau_Seva", label: "Gau Seva"},
  { id: "Deity_Worship", label: "Deity Worship" },
  { id: "Sankirtan_Seva", label: "Sankirtan Seva" },
  { id: "Gita_Daan", label: "Gita Daan"},
 
];

